<template>
    <el-dialog title=""  class="global-dialog"
               :visible.sync="dialogVisible"
               :append-to-body="true" width="640px">
        <div class="p-f-body">
            <p class="c-gray">该项目已存在，相同项目名称不可重复创建</p>
        </div>
        <div slot="footer">
            <el-button type="primary" @click="confirm">我知道了</el-button>
        </div>
    </el-dialog>
</template>
<script>
    export default {
        props: {
            value: {type: Boolean, default: false}
        },
        data () {
            return {
            };
        },
        computed: {
            dialogVisible: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit('input', v);
                }
            }
        },
        methods: {
            confirm () {
                this.$emit('input', false);
            }
        }
    }
</script>